import script from "./GptChartIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./GptChartIndex.vue?vue&type=script&setup=true&lang=js"

import "./GptChartIndex.vue?vue&type=style&index=0&id=3cbe4e47&lang=less&scoped=true"

import exportComponent from "D:\\zyr\\gptm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cbe4e47"]])

export default __exports__